export const TAB = 9;
export const ENTER = 13;
export const SPACE = 32;
